/**
 * Formatea un monto con prefijo $ y código de moneda, o retorna '—' si no hay valor.
 */
export const formatQuotePrice = (
  amount: number | string | null | undefined,
  currency?: string | null
): string => {
  if (amount === null || amount === undefined || amount === '') return '—';

  const numericAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (Number.isNaN(numericAmount)) return '—';

  const formatted = numericAmount.toLocaleString('es', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return currency ? `$${formatted} ${currency}` : `$${formatted}`;
};
